/**
 * AVISO DE LECTURA (F13.3) — sonido y vibración
 *
 * Un pitido generado (Web Audio; no hay ficheros de audio) y, si el navegador
 * lo permite, una vibración corta. Cada resultado suena distinto para poder
 * trabajar sin mirar la pantalla. Si el navegador no lo permite, no pasa nada.
 */
export type TipoAviso = 'exito' | 'ambiguo' | 'desconocido' | 'error';

let contexto: AudioContext | null = null;

function tono(frecuencia: number, ms: number, inicio = 0): void {
  const C = (globalThis as { AudioContext?: typeof AudioContext }).AudioContext;
  if (C === undefined) return;
  contexto ??= new C();
  const o = contexto.createOscillator();
  const g = contexto.createGain();
  o.frequency.value = frecuencia;
  g.gain.value = 0.08;
  o.connect(g);
  g.connect(contexto.destination);
  const t = contexto.currentTime + inicio;
  o.start(t);
  o.stop(t + ms / 1000);
}

export function avisar(tipo: TipoAviso): void {
  try {
    if (tipo === 'exito') tono(1320, 90);
    else if (tipo === 'ambiguo') { tono(880, 90); tono(880, 90, 0.14); }
    else { tono(330, 220); }
    const vibrar = (navigator as { vibrate?: (p: number | number[]) => boolean }).vibrate;
    vibrar?.call(navigator, tipo === 'exito' ? 60 : tipo === 'ambiguo' ? [50, 60, 50] : [200]);
  } catch {
    /* sin audio ni vibración: el aviso visual basta */
  }
}
